"use client";

import { useState } from 'react';
import { Link } from 'react-router-dom';
import contractImg1 from '../../assets/images/resources/factoryforcontact.png';
import contractShape1 from '../../assets/images/shapes/contact-three-shape-1.png';
import locationMap from '../../assets/images/shapes/location-map.png';
import successPic from '../../assets/images/icon/success.png'
import { Modal, ModalHeader } from 'react-bootstrap';
import axios from 'axios';
// Define a list of services for the dropdown
const services = [
  "Choose an Option",
  "Movable Excavator",
  "Scrap Magnet",
  "Vertical Heavy Duty Scrap Shear",
  "Hydraulic Scrap Baler",
  "Horizotal Automatic Container Shear",
  "Fixed Boom Excavator",
  "Scrap Grabber"
];

export default function ContactThree() {
  const [selectedService, setSelectedService] = useState(services[0]);
  const [showModal, setShowModal] = useState(false)
  const [data, setData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  })
  // const [error, setError] = useState("");
  console.log('datafromform', data)


  const handleCloseModal = () => {
    setShowModal(false)
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;


  //   if (name === "mobile") {

  //     if (/^\d*$/.test(value)) {
  //       setData({ ...data, [name]: value });

  //       if (value.length === 10) {
  //         setError("");
  //       } else {
  //         setError("Mobile number must be of exactly 10 digits");

  //       }
  //     }
  //   } else {
  //     // For all other inputs
  //     setData({ ...data, [name]: value });
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form Data:', data);
    const payload = {
      ...data,
      machineName: selectedService,
      website: 'Ramana Steels'
    }
    try {
      // const response = await axios.post('http://localhost:4000/userform', payload);
      const response = await axios.post('https://api.ramanamachines.com:4000/userform', payload);

      setData({
        name: '',
        email: '',
        message: '',
        mobile: ''
      })
      setSelectedService(services[0])
      if (response) { setShowModal(true) }


    }
    catch { }
  }

  return (
    <>
      {/* Contact Three Start */}
      <section className="contact-three">
        <div className="container" style={{ marginBottom: '120px' }}>
          <div className="row">
            <div className="col-xl-6 wow fadeInLeft" data-wow-delay="100ms">
              <div className="contact-three__left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Contact With Us</span>
                  </div>
                  <h2 className="section-title__title">
                    Trust the Experts in ,<span> Scrap Processing </span>& <span>Recycling Solutions</span>
                  </h2>
                </div>
                <div className="contact-three__img">
                  <img src={contractImg1} alt="" />
                </div>
                <ul className="contact-three__points list-unstyled">
                  <li>
                    <div className="icon">
                      <span className="icon-cheack"></span>
                    </div>
                    <p> <strong>Industry-Leading Scrap Machinery</strong><br />
                      We specialize in customized solutions for scrap yards, steel plants, and metal recycling industries.</p>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-cheack"></span>
                    </div>
                    <p><strong>Comprehensive Equipment Range</strong><br />
                      From shearing and baling machines to shredders and sorting systems, we provide high-efficiency scrap processing solutions.</p>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-cheack"></span>
                    </div>
                    <p><strong>Trusted by Hundreds Worldwide</strong><br />
                      With 200+ successful projects, we are the go-to partner for scrap management and metal recovery solutions.</p>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-cheack"></span>
                    </div>
                    <p><strong>📞 Get in Touch for a Customized Quote!</strong><br />
                      Fill out the form to discuss your needs, and our experts will provide a tailored solution.
                    </p>
                  </li>
                </ul>
                {/* <div className="contact-three__btn-box">
                  <Link to="/contact" className="contact-three__btn thm-btn">
                    Read more<span className="icon-dubble-arrow-right"></span>
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="col-xl-6 wow fadeInRight" data-wow-delay="300ms">
              <div className="contact-three__right">
                <div className="contact-three__shape-1">
                  <img src={contractShape1} alt="" />
                </div>
                <h3 className="contact-three__right-title">Contact Us</h3>
                <form
                  className="contact-form-validated contact-three__form"
                  action="/assets/inc/sendemail.php"
                  method="post"
                  noValidate
                >
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Name</h4>
                        <input type="text" name="name" placeholder="Your Name" value={data.name} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Email</h4>
                        <input type="email" name="email" placeholder="Your Email" value={data.email} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Number</h4>
                        {/* <input
                          type="text"
                          name="mobile"
                          placeholder="Please enter a valid 10-digit number"
                          value={data.mobile}
                          onChange={handleChange}
                          required
                          pattern="\d{10}"
                          title="Please enter a valid 10-digit number"
                        /> */}
                        <input type="text" name="mobile" placeholder="Your Number" value={data.mobile} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Option</h4>
                        <div className="select-box">
                          <select
                            className="selectmenu wide"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                          >
                            {services.map((service, index) => (
                              <option key={index} value={service}>
                                {service}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <h4 className="contact-three__input-title">Message</h4>
                      <div className="contact-three__input-box text-message-box">
                        <textarea name="message" value={data.message} onChange={handleChange} placeholder="Message here.."></textarea>
                      </div>
                      <div className="contact-three__btn-box-two">
                        <button type="submit" className="thm-btn-two contact-three__btn-two" onClick={handleSubmit}>
                          Contact Now<span className="icon-dubble-arrow-right"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="result"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="global-presence shadow p-3 mb-3 bg-gray">
          <div className="overlay"></div> {/* Overlay div for opacity effect */}
          <h3>Global Presence, Trusted Worldwide</h3>
          <p>
            Ramana Machines has expanded its reach beyond India, successfully installing machines in numerous countries across the globe. Our machines are now operating in Nepal, Bangladesh, Sri Lanka, Bhutan, South Africa, Nigeria, UAE, and many more. With each installation, we continue to demonstrate our commitment to delivering high-quality machinery and expert service, no matter where you are. Join the growing list of satisfied global customers who trust Ramana Machines for their industry needs.
          </p>
        </div>
        {/* <div className='shadow p-3 mb-3 bg-gray' style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '80px', alignItems: 'center', backgroundImage: `url(${locationMap})`, maxWidth: '1218px', height: '672px', margin: 'auto' }}>
          <h3>Global Presence, Trusted Worldwide</h3>
          <p>Ramana Machines has expanded its reach beyond India, successfully installing machines in numerous countries across the globe. Our machines are now operating in Nepal, Bangladesh, Sri Lanka, Bhutan, South Africa, Nigeria, UAE, and many more. With each installation, we continue to demonstrate our commitment to delivering high-quality machinery and expert service, no matter where you are. Join the growing list of satisfied global customers who trust Ramana Machines for their industry needs.

          </p>

        </div> */}
      </section>
      {/* Contact Three End */}

      <Modal show={showModal} size="sm" onHide={handleCloseModal} centered>
        <Modal.Header closeButton className="border-0 justify-content-center">

        </Modal.Header>
        <Modal.Body className="text-center">
          <img src={successPic} style={{ width: "100px", height: "100px", marginBottom: '20px' }} alt='success' />
          <p>Form submitted successfully!</p>
          <p>Thank you for showing interest!</p>
        </Modal.Body>
      </Modal>
    </>
  );
}
